import { AccountsService } from 'base/accounts_service';
import { Button } from 'base/ui/button';
import { RedErrorText } from 'base/ui/form';
import { FormInput } from 'base/ui/input';
import { Rows } from 'base/ui/layout';
import { TextSmallLight, Title0 } from 'base/ui/typography';
import { observer } from 'mobx-react-lite';
import { fromPromise } from 'mobx-utils';
import React from 'react';
import { AnnouncementDialog } from './dashboard/announcement';
import { StringHashParameterStore } from './hash_parameter';

const announcementId = new StringHashParameterStore('announcementId');

export const AnnouncementPlayground = observer(function _AP({
  service,
}: {
  service: AccountsService;
}) {
  const id = announcementId.get() || '1';
  const state = React.useMemo(
    () => fromPromise(service.getAnnouncement(id)),
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id],
  );
  const [open, setOpen] = React.useState(true);

  return (
    <Rows spacing={16}>
      <div />
      <Title0>Announcement Playground</Title0>
      <div />
      <Rows spacing={8}>
        <TextSmallLight color="grey">Announcement ID</TextSmallLight>
        <FormInput
          variant="darker"
          type="number"
          value={id}
          onChange={(v) => announcementId.set(v)}
        />
      </Rows>
      <div />
      <Button
        onClick={() => setOpen(true)}
        disabled={state.state !== 'fulfilled'}
        label="Open Dialog"
        loading={state.state === 'pending'}
      />
      {state.state === 'rejected' && <RedErrorText error={state.value} />}
      {state.state === 'fulfilled' && open && (
        <AnnouncementDialog
          value={state.value}
          onClose={() => setOpen(false)}
          onLearnMore={() => {}}
        />
      )}
    </Rows>
  );
});
